import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'gridEvalSize',
	pure: true,
	standalone: true
})
export class NHAGridEvalSizePipe implements PipeTransform {
	transform(size: number | ((item: unknown) => number), item: unknown): number {
		if (typeof size === 'function') {
			return size(item);
		}
		return size;
	}
}
